require('new_design/desktop/phones_selector');
